module.exports = __webpack_public_path__ + "img/16_52.c65ad573.png";